/* eslint-disable @typescript-eslint/no-explicit-any */
import { createReducer } from 'reduxsauce'

import { DiscordServerTypes } from 'store/actions'
import { DISCORD_SERVER_INITIAL_STATE, SOLANA_NFT_INITIAL_STATE } from 'store/states'

/* ------------- Reducers ------------- */

export const resetDiscordServerData = (state: any) => {
  return {
    ...state,
    hasDataToLoad: true,
    collection: [],
  }
}

export const getDiscordServerData = (state: any, { payload }: any) => {
  const { loading } = payload
  return {
    ...state,
    loading,
    isRequesting: true,
  }
}

export const setDiscordServerData = (state: any, { payload }: any) => {
  const { collection, limit, hasDataToLoad } = payload

  console.log('PAYLOAD')
  console.log(payload)
  let newCollection: any = []
  if (!collection) {
    newCollection = [...state.collection]
  } else {
    newCollection = [...state.collection]
    collection.forEach((data: any) => {
      const exists = newCollection.find((d: any) => d.id === data.id)
      if (!exists) {
        newCollection.push(data)
      }
    })
  }

  return {
    ...state,
    limit,
    hasDataToLoad,
    collection: newCollection,
    loading: false,
    isRequesting: false,
    hasInitialized: true,
  }
}

export const updateDiscordServerDocument = (state: any, { payload }: any) => {
  // eslint-disable-next-line camelcase
  const { status, channel_ids, slug, id } = payload

  const updatedCollection = state.collection.map((data: any) => {
    if (data.id === id) {
      return {
        ...data,
        slug: slug,
        status: status,
        // eslint-disable-next-line camelcase
        channel_ids: channel_ids,
      }
    }

    return data
  })

  return {
    ...state,
    collection: updatedCollection,
    loading: false,
    isRequesting: false,
    hasInitialized: true,
  }
}

export const deleteDiscordServerDocument = (state: any, { payload }: any) => {
  const { id } = payload

  const updatedCollection = state.collection.filter(
    (data: any) => data.invalid_magic_eden_slug_id !== id,
  )

  return {
    ...state,
    collection: updatedCollection,
    loading: false,
    isRequesting: false,
    hasInitialized: true,
  }
}

/* ------------- Hookup Reducers To Types ------------- */

export const discordServerReducer = createReducer(DISCORD_SERVER_INITIAL_STATE, {
  // Mint Collection
  [DiscordServerTypes.RESET_DISCORD_SERVER_DATA]: resetDiscordServerData,
  [DiscordServerTypes.GET_DISCORD_SERVER_DATA]: getDiscordServerData,
  [DiscordServerTypes.SET_DISCORD_SERVER_DATA]: setDiscordServerData,
  [DiscordServerTypes.UPDATE_DISCORD_SERVER_DOCUMENT]: updateDiscordServerDocument,
  [DiscordServerTypes.DELETE_DISCORD_SERVER_DOCUMENT]: deleteDiscordServerDocument,
})
